import React from 'react'
import { PlayIcon } from '@heroicons/react/24/solid'
import {
  PlayButton
} from './styles'

const PlayButtonOverlay = ({ onPlay, isPlaying }) => {
  return (
    <div 
      className={`
        z-50 absolute top-1/2 left-0 right-0 -translate-y-1/2
        ${!isPlaying ? 'opacity-100' : ''}
        ${isPlaying? 'opacity-0 transition-opacity duration-1000 ease-out' : ''}
      `}>
      <div className='text-center px-8 text-2xl uppercase font-bold text-black'>
        <span style={{ 
          background: '#ff7cd6',
          transform: 'skew(-10deg)'
        }} className='inline-block px-2'>exclusive fussy content</span>
      </div>
      <PlayButton onClick={onPlay} className='bg-white text-black px-6 py-4 text-3xl uppercase font-bold rounded-full mt-4 mx-auto flex items-center'>
        <PlayIcon className='inline-block w-8 h-8 mr-2' />
        Play Now
      </PlayButton>
    </div>
  )
}

export default PlayButtonOverlay